import { z } from 'zod';
import { addCtaPairIssues, addPublishWindowIssues, adminMetadataSchema, contentStatusChangeSchema, nonEmptyUpdate, publishWindowShape, safeLinkSchema, slugSchema, } from './common.js';
const bannerEditableShape = {
    slug: slugSchema,
    titulo: z.string().min(1),
    mensaje: z.string().min(1),
    ctaLabel: z.string().min(1).nullable(),
    ctaUrl: safeLinkSchema.nullable(),
    placement: z.enum(['modal', 'strip']),
    orden: z.number().int(),
};
const bannerWriteShape = { ...bannerEditableShape, ...publishWindowShape };
export const createBannerSchema = z
    .object({
    ...bannerEditableShape,
    placement: bannerEditableShape.placement.optional(),
    orden: bannerEditableShape.orden.optional(),
    status: publishWindowShape.status.optional(),
    publishAt: publishWindowShape.publishAt.optional(),
    unpublishAt: publishWindowShape.unpublishAt.optional(),
})
    .superRefine((value, context) => {
    addPublishWindowIssues(value, context);
    addCtaPairIssues(value, context);
});
export const updateBannerSchema = nonEmptyUpdate(z.object(bannerWriteShape));
export const bannerStatusChangeSchema = contentStatusChangeSchema;
export const publicBannerSchema = z.object({
    slug: bannerEditableShape.slug,
    titulo: bannerEditableShape.titulo,
    mensaje: bannerEditableShape.mensaje,
    ctaLabel: bannerEditableShape.ctaLabel,
    ctaUrl: bannerEditableShape.ctaUrl,
    placement: bannerEditableShape.placement,
});
export const publicBannerListSchema = z.array(publicBannerSchema);
export const publicBannerFields = Object.freeze(Object.keys(publicBannerSchema.shape));
export const adminBannerSchema = z
    .object({ id: z.number().int().positive(), ...bannerWriteShape })
    .extend(adminMetadataSchema.shape);
export const adminBannerListSchema = z.array(adminBannerSchema);
export const bannerPreviewSchema = z.object({
    content: publicBannerSchema,
    effectiveVisibility: adminMetadataSchema.shape.effectiveVisibility,
    publishAt: publishWindowShape.publishAt,
    unpublishAt: publishWindowShape.unpublishAt,
});
//# sourceMappingURL=banners.js.map